import api from '@shared/services/api';
import { Transfer } from '@client/domain/transfer';

// eslint-disable-next-line import/prefer-default-export
export const transfer = (data: Transfer): Promise<Transfer> => api.post('v1/transfers', {
  body: data,
});
